export default __webpack_public_path__ + "54fb1b8ad55efdaa5e84c7cfa5ad5d57.png";